import { render, staticRenderFns } from "./AtlasLogo.vue?vue&type=template&id=a6fa447e&scoped=true&"
var script = {}
import style0 from "./AtlasLogo.vue?vue&type=style&index=0&id=a6fa447e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa447e",
  null
  
)

export default component.exports